import React, { useEffect, useRef, useState } from "react";
import { usePermission } from "../../../context/PermissionContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import EditStock from "../stockbatch/EditStock";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import StockIn from "../stockbatch/StockIn";
import StockOut from "../stockbatch/StockOut";
import AddStockModel from "./AddStockModel";
import handleError from "../../../constants/handleError";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import BarcodeGenerator from "./BarCode";
import uRLs from "../../../utils/baseUtils";
import { toSecondaryQuantity } from "@heartinz/finance";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { AddIcon, BarcodeIcon, DeleteIcon } from "../../../constants/Icons";

const StockDetails = ({
  stockData,
  onData,
  closeEditStockModal,
  handleStockUpdate,
  isStockEditModalOpen,
  setStockEditModalOpen,
  isStockInModalOpen,
  closeStockInModal,
  setStockInModalOpen,
  handleStockIn,
  isStockOutModalOpen,
  closeStockOutModal,
  handleStockTrash,
  setStockOutModalOpen,
  addStockOpen,
  closeAddStockModel,
  handleupdateListStock,
  handleStockAdd,
  handleCreateStock,
  setAddStocOpen,
  btnLoading,
}) => {
  const { permission, viewOption, hasPermission } = usePermission();
  const { isUser } = useAuth();
  const showAlert = useShowAlert();
  const { getColor } = useContextApi();
  const { checkNetwork } = useNetwork();
  const handleUpdateRef = useRef();
  const [data, setData] = useState(onData);
  const [finalLandingCost, setFinalLandingCost] = useState([]);
  const [isStockEditData, setStockEditData] = useState([]);
  const [isStockInData, setStockInData] = useState("");
  const [isStockOutData, setStockOutData] = useState("");
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const openEditStcokModal = (cItem, cIndex) => {
    if (hasPermission("STOCK", "STOCK:update") || permission === undefined) {
      const isValidDate = (date) => date && !isNaN(new Date(date).getTime());
      setStockEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
        manufacturedate: isValidDate(cItem?.manufacturedate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.manufacturedate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        expiredate: isValidDate(cItem?.expiredate)
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.toISO(
                formatDate(new Date(cItem?.expiredate)),
                "yyyy-MM-dd",
                isUser.timezone,
              ),
            ).date
          : "",
        cIndex: cIndex,
      });
      setStockEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleClickBarcode = (code) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:viewByCode") ||
      permission === undefined
    ) {
      setSelectedBarcode(code); // set the selected barcode
      setShowBarcodeModal(true); // show the modal
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openStockInModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:updateStockin") ||
      permission === undefined
    ) {
      setStockInModalOpen(true);
      cItem.cIndex = index;
      setStockInData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openDeleteTrashModal = (cItem, index) => {
    if (
      hasPermission("STOCK", "STOCK:deleteTrash") ||
      permission === undefined
    ) {
      setStockOutModalOpen(true);
      cItem.cIndex = index;
      setStockOutData(cItem);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const openAddStockModel = async (product) => {
    await getFinalLandingCost(
      product?.stockLinkId,
      product?.stockid,
      product?._id,
    );
    setAddStocOpen(true);
  };
  const getFinalLandingCost = async (stocklinkid, stockid, productid) => {
    try {
      if (!checkNetwork()) return;

      const params = new URLSearchParams();

      // always add productid
      params.append("productid", productid);

      // add stockid only if not null/undefined/empty
      if (stockid !== null && stockid !== undefined && stockid !== "") {
        params.append("stockid", stockid);
      }

      // add stocklinkid only if not null/undefined/empty
      if (
        stocklinkid !== null &&
        stocklinkid !== undefined &&
        stocklinkid !== ""
      ) {
        params.append("stocklinkid", stocklinkid);
      }

      const response = await AxiosInstance.get(
        `module/stock/final-landingcost?${params.toString()}`,
      );
      // const response = await AxiosInstance.get(`module/stock/final-landingcost?${stocklinkid}
      // &stockid=${stockid}&productid=${productid}`);
      setFinalLandingCost(response.data?.results?.finalLandingCost);
      return response.data?.results?.finalLandingCost;
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  useEffect(() => {
    if (onData?.updated) {
      setData({
        ...onData,
        mrp: CurrencyConverter.toSubunit(onData?.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(onData?.saleprice, "INR"),
        discount: CurrencyConverter.toSubunit(onData?.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(onData?.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(onData?.taxamount, "INR"),
        landingcost: CurrencyConverter.toSubunit(
          onData?.landingcost || 0,
          "INR",
        ),
        updated: false,
      });
    } else {
      setData(onData);
    }
  }, []);

  return (
    <>
      <div className="d-block d-flex justify-content-between mb-4">
        <div></div>
        {/* <h6 className="text-center py-2">
          <span className="badge rounded-pill bg-label-navy">
            {data?.code}{" "}
          </span>
          &nbsp;- {data?.title}
        </h6> */}
        <div className="d-flex ">
          <button
            onClick={() => openAddStockModel(data)}
            ref={handleUpdateRef}
            type="button"
            className="btn btn-teal text-right"
          >
            <AddIcon/> Add Stock
          </button>
          {/* <div className="order-actions ">
          <button
                  type="button"
                  className="btn-label-primary shadow-none ms-2"
                  onClick={(e) => {
                  e.stopPropagation();
                  handleClickBarcode(onData);
                  }}
                >
                  <i className="bx bx-barcode"></i>
              </button>
              </div> */}
        </div>
      </div>

      <Table
        data={stockData}
        trClass={true}
        onRowClick={(item, index) => {
          if (isUser.stype === "MAIN") {
            openEditStcokModal(item, index);
          } else {
            openDeleteTrashModal(item, index);
          }
        }}
        columns={[
          {
            label: "MRP",
            render: (item) => (
              <span className="badge bg-label-fall rounded-pill">
                ₹{CurrencyConverter.toCurrency(item?.mrp || 0, "INR")}
              </span>
            ),
          },
          {
            label: "Sale Price",
            render: (item) => (
              <span className="badge bg-label-food rounded-pill">
                ₹{CurrencyConverter.toCurrency(item?.saleprice || 0, "INR")}
              </span>
            ),
          },
          {
            label: "Tax(%)",
            render: (item) => (
              <span className="badge rounded-pill bg-label-peace">
                {item.taxpercentage}%
              </span>
            ),
          },
          {
            label: "LandingCost",
            render: (item) => (
              <span className="badge bg-label-secondary rounded-pill">
                ₹{CurrencyConverter.toCurrency(item?.landingcost || 0, "INR")}
              </span>
            ),
          },
          viewOption("stockSettings", "isManufactureAndExpiryDates") && {
            label: "Date",
            render: (item) => (
              <>
                <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                  MFD :{" "}
                  {item?.manufacturedate
                    ? DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item?.manufacturedate,
                          isUser.timezone,
                        ),
                      ).date
                    : ""}
                </small>
                <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                  EXP :{" "}
                  {item?.expiredate
                    ? DateConverter.ISOToDisplayFormat(
                        item.expiredate,
                        isUser.timezone,
                      ).date
                    : ""}
                </small>
              </>
            ),
          },
          {
            label: "Stock Left",
            render: (item) => (
              <>
                {" "}
                <span className="badge bg-label-space mx-1">
                  {Number(
                    item?.isSecondaryUnit
                      ? secondaryQuanity(item.stockLeft, item?.unitConfig)
                      : item?.stockLeft,
                  )}{" "}
                  <span className="font-11 ms-1">
                    {(() => {
                      const unitCode = item?.isSecondaryUnit
                        ? item?.unitConfig?.secondaryUnitCode
                        : item?.unitConfig?.primaryUnitCode;

                      return unitCode !== "unit" ? unitCode : "";
                    })()}
                  </span>
                </span>
                /{" "}
                <span className="badge bg-label-spring">
                  {Number(
                    item?.isSecondaryUnit
                      ? secondaryQuanity(item.stockIn, item?.unitConfig)
                      : item?.stockIn,
                  )}
                  {""}
                  <span className="font-11 ms-1">
                    {(() => {
                      const unitCode = item?.isSecondaryUnit
                        ? item?.unitConfig?.secondaryUnitCode
                        : item?.unitConfig?.primaryUnitCode;

                      return unitCode !== "unit" ? unitCode : "";
                    })()}
                  </span>
                </span>
              </>
            ),
          },
          {
            label: "Action",
            render: (item, index) => (
              <div className="order-actions opacity-0 opacity-md-100 d-flex align-items-center justify-content-center">
                {isUser.stype === "MAIN" && (
                  <>
                    {/* <button
                              type="button"
                              className="btn btn-sm btn-label-teal  shadow-none me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditStcokModal(item, index);
                              }}
                            >
                              <i className="ng ng-ng-edit-icon"></i>
                            </button>

                            <button
                            type="button"
                            className="btn btn-sm btn-label-teal  shadow-none me-2 "
                            onClick={(e) => {
                              e.stopPropagation();
                              openStockInModal(item, index);
                            }}
                          >
                            <i className="ng ng-ng-add-icon"></i>{" "}
                            Stock
                          </button> */}
                  </>
                )}
                {/* <button
                          type="button"
                          className="btn btn-sm btn-label-teal  shadow-none me-2 "
                          onClick={(e) => {
                            e.stopPropagation();
                            openStockInModal(item, index);
                          }}
                        >
                          <i className="ng ng-ng-add-icon"></i>{" "}
                          Stock
                        </button> */}
                <button
                  type="button"
                  className="btn-label-primary shadow-none me-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClickBarcode(item);
                  }}
                >
                  <BarcodeIcon/>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-label-danger shadow-none"
                  onClick={(e) => {
                    e.stopPropagation();
                    openDeleteTrashModal(item, index);
                  }}
                >
                  <DeleteIcon/>
                </button>
              </div>
            ),
          },
        ].filter(Boolean)}
      />
      {isStockEditModalOpen && (
        <EditStock
          editData={isStockEditData}
          onClose={closeEditStockModal}
          onEdit={handleStockUpdate}
          isBtnLoading={btnLoading}
        />
      )}
      {isStockInModalOpen && (
        <StockIn
          data={isStockInData}
          onClose={closeStockInModal}
          onEdit={handleStockIn}
          isBtnLoading={btnLoading}
        />
      )}
      {isStockOutModalOpen && (
        <StockOut
          data={isStockOutData}
          onClose={closeStockOutModal}
          onEdit={handleStockTrash}
          isBtnLoading={btnLoading}
        />
      )}
      {addStockOpen && (
        <AddStockModel
          onclose={closeAddStockModel}
          onData={data}
          stokData={stockData}
          onUpdate={handleupdateListStock}
          onStockAdd={handleStockAdd}
          isBtnLoading={btnLoading}
          onStockCreate={handleCreateStock}
          finalLand={finalLandingCost}
        />
      )}
      {showBarcodeModal && uRLs.BARCODE_PRINT === "true" && (
        <BarcodeGenerator
          barcodeValue={selectedBarcode.code}
          product={selectedBarcode}
          onClose={() => setShowBarcodeModal(false)}
        />
      )}
    </>
  );
};

export default StockDetails;
